import { useState } from 'react'
import AxiosInstance from '../../../Helper/AxiosInstance';
import { toast } from 'react-toastify';
import { C, fBody } from '../../../Shared/Brand';
import { PageHeader, TabBar } from '../../../Shared/DashboardUI';

export default function ChangePassword() {
    const empty = { btnLoader: false, oldPass: '', newPass: '', confPass: '', type: 1 }
    const [data, setData] = useState(empty)
    const hendalInput = (event) => {
        const target = event.currentTarget
        setData(prev => ({ ...prev, [target.name]: target?.files?.[0] || target?.value || '' }))
    }
    const manageRequest = async (event) => {
        event.preventDefault()
        try {
            setData((prev) => ({ ...prev, btnLoader: true }))
            const response = await AxiosInstance.post('/changepassword', data)
            if (response.status === 1) {
                setData((prev) => ({ ...prev, ...empty }))
                toast.success(response.mess, { position: 'top-center', autoClose: 700 })
                return
            }
            toast.warn(response.mess, { position: 'top-center', autoClose: 700 })
        } catch (err) { } finally {
            setData((prev) => ({ ...prev, btnLoader: false }))
        }
    }
    return (<>
        <PageHeader title="Account Security" />
        <div style={{ maxWidth: '480px' }}>
            <TabBar
                tabs={[{ key: 1, label: 'Login Password' }, { key: 2, label: 'Truncation Password' }]}
                active={data.type}
                onChange={(type) => setData((prev) => ({ ...prev, ...empty, type }))}
            />
            <div className="xdb-card">
                <h5 style={{ fontSize: '14px', fontWeight: 700, color: C.ltx, marginTop: 0, marginBottom: '16px', fontFamily: fBody }}>
                    Change {['', 'Login', 'Truncation'][data?.type]} Password
                </h5>
                <form onSubmit={manageRequest}>
                    <div style={{ marginBottom: '14px' }}>
                        <label className="xdb-label" htmlFor="oldPass">Password</label>
                        <input type="password" className="xdb-input" id="oldPass" name="oldPass" value={data?.oldPass} onChange={hendalInput} required />
                    </div>
                    <div style={{ marginBottom: '14px' }}>
                        <label className="xdb-label" htmlFor="newPass">New Password</label>
                        <input type="password" className="xdb-input" id="newPass" name="newPass" value={data?.newPass} onChange={hendalInput} required />
                    </div>
                    <div style={{ marginBottom: '18px' }}>
                        <label className="xdb-label" htmlFor="confPass">Confirm Password</label>
                        <input type="password" className="xdb-input" id="confPass" name="confPass" value={data?.confPass} onChange={hendalInput} required />
                    </div>
                    <button type="submit" className="xdb-btn" disabled={data?.btnLoader} style={{ opacity: data?.btnLoader ? 0.6 : 1 }}>
                        {data?.btnLoader ? 'Submitting…' : 'Submit'}
                    </button>
                </form>
            </div>
        </div>
    </>)
}
